<template>
	<div class="ld" :class="[loading ? 'ld--active': '', static ? 'ld--static': '']">
		<div class="ld__container">
			<transition name="fade">
				<svg class="svg-icon ld__icon" v-if="loading" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 38 38">
					<g  fill="none">
						<circle cx="19" cy="19" r="18" stroke="currentColor" stroke-opacity=".3"></circle>
						<path d="M37,19c0-9.9-8.1-18-18-18" stroke="currentColor"></path>
					</g>
				</svg>
			</transition>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		loading: {
			type: Boolean,
			default: false
		},

		static: {
			type: Boolean,
			default: false
		}
	}
};
</script>